export interface DriverProfile {
  id: string;
  driver_id: string;
  cdl_license_number: string;
  license_state: string;
  dob: Date | null;
  hire_date: Date | null;
  last_random_test_drug_date: Date | null;
  notes: string | null;
  admin_notes: string | null;
  document_type: BcDocumentType;
  gender: string;
  citizenship: string | null;
  fast_card: string | null;
  travel_documents: TravelDocument[];
}

export enum BcDocumentType {
  TRAVEL_DOCUMENTS = 'travel-documents',
  FAST_CARD = 'fast-card'
}

export interface TravelDocument {
  type: string;
  number: string;
  state_province: string | null | undefined;
  country: string | null | undefined;
}

export type EditDriverProfileParams = Partial<Omit<DriverProfile, 'id' | 'driver_id'>>;
